import React, { Component, useState } from "react";
import {
  ComponentBox,
  DataView,
  DataWrapperClass,
  DateView,
  UserName,
  ContentData,
  BoxData,
  IconData,
  TagLine,
  DescData,
  DataViewList,
  EditorCSS,
  InsightRow,
  Header,
  HeaderAgent,
} from "../styles/main";
import { Accordion, Col, MenuItem, Row, Tab, Tabs } from "react-bootstrap";
import {
  DataWithLoader,
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  SeachForm,
  Alert,
  ButtonCommonTheme,
  Tip,
} from "modules/theme";
import Select from "react-select-plus";
import styled from "styled-components";
import { Editor } from "react-draft-wysiwyg";
import APIManager from "modules/common/apiManager";
import {
  convertToRaw,
  EditorState,
  ContentState,
  Modifier,
  convertFromHTML,
} from "draft-js";
import draftToHtmlPuri from "draftjs-to-html";
import { PerPage } from "helpers/system-config";
import htmlToDraft from "html-to-draftjs";
import { connect } from "react-redux";
import {
  chatSelector,
  globalStateSelector,
  smsemailSelector,
} from "../../../../../store/selector";
import {
  callAction,
  chatAction,
  smsemailAction,
} from "../../../../../store/action";
import { Spinner } from "modules/common/components";
import { smsCounter } from "../../../../common/utils";
import MessageScreenBody from "../../../../screens/chatscreen/components/MessageScreenBody/MessageScreenBody";
import { RenderInitials } from "../../../../screens/chatscreen/components/Avatar";
import {
  getName,
  getNameCall,
  getPlatform,
} from "../../../../screens/chatscreen/components/utils/generic";
import { CustomDropdown } from "modules/common/components";

import "./ContactInfoActivityTimelineTheme.css";
import { FaWandMagicSparkles } from "react-icons/fa6";
import ContactInfoSmartAgent from "./ContactInfoSmartAgent";
import SummarySectionComponent from "./SummarySectionComponent";
// import Editor from './Editor';
const CharacterCounts = styled.div`
  display: flex;
  justify-content: flex-end;
  .dark-text {
    font-weight: 500;
    margin-right: 5px;
  }
`;
const SMForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  .sc-igwadP.cibmtx {
    width: 90%;
  }
  // flex-direction:row;
  // align-items:stretch;
`;
const Button = styled.button`
  background: ${(props) => (props.bgColor === "blue" ? "#28a6de" : "#ff0d0d")};
  border: none;
  color: #fff;
  font-family: "Poppins";
  padding: 6px 22px;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  border-radius: 6px;
`;
const TextArea = styled.textarea`
  height: 100px;
  width: 100%;
`;
const GreyText = styled.div`
  height: 21px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  background: ${(props) => (props.isSelected ? "#e0e0e0" : "")};
  &:hover {
    background: #e0e0e0;
  }
`;
const ResetCss = styled.div`
  img {
    height: auto;
    width: auto;
    border-radius: 0px;
  }
  // .public-DraftStyleDefault-ltr {
  //   direction: ltr;
  //   /* border: 2px solid black; */
  //   text-align: left;
  //   background: #FFFFFF;
  //   box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  //   border-radius: 10px;
  //   height: 100px;
  //   width: 90%;
  //   margin: 15px auto;
  //   padding: 5px;
  // }
  .rdw-editor-toolbar {
    margin-bottom: 0px;
  }
  .DraftEditor-root {
    overflow: hidden;
    word-break: break-all;
    z-index: 0;
    direction: ltr;
    text-align: left;
    background: #ffffff;
    /* box-shadow: 0px 3px 20px rgb(0 0 0 / 10%); */
    /* border-radius: 10px; */
    height: 130px;
    overflow: auto;
    border: 1px solid #f1f1f1;
    /* width: 95%; */
    border-top: none;
    min-height: 113px;
    margin: 0px;
    padding: 5px;
  }
`;
const Label = styled.label`
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden; /* Chrome and Safari */
  -moz-backface-visibility: hidden; /* Firefox */
  -ms-backface-visibility: hidden; /* Internet Explorer */
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  &:hover {
    background: #ececec;
  }
`;

const TabItemsStyle = styled.div`
  height: 100%;
  width: 100%;
  .tabItemStyle {
    display: flex;
    // align-items: flex-end;
    // height: 52px;
    // padding: 0px 20px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tab-content,
  .tab-pane {
    height: 100%;
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    // display: flex;
    // -webkit-box-align: center;
    // align-items: center;
    // position: relative;
    // flex-flow: row-reverse wrap;
    // -webkit-box-pack: start;
    // justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    border-bottom: 1px solid rgb(226, 232, 239);
    padding: 30px 20px 0px 20px;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  padding: 70px;
  color: #888;
  gap: 10px;

  img {
    max-height: 260px;
    width: auto;
    margin: auto;
  }
`;

export class ContactInfoActivityTimelineTheme extends Component {
  constructor(props) {
    super(props);
    this.textAreaRef = React.createRef();
    this.mAPI = new APIManager();
    this.open = this.open.bind(this);
    this.renderActivity = this.renderActivity.bind(this);
    this.renderActivityList = this.renderActivityList.bind(this);
    this.saveData = this.saveData.bind(this);
    this.textAreaStyle = {
      height: "180px",
      width: "100%",
      padding: "15px",
      outline: "none",
    };
    this.state = {
      isActive: false,
      list: this.processData(props.comments),
      valueForBcc: [],
      valueForCC: [],
      valueForTo: [],
      defaultcc: [],
      defaultBcc: [],
      defaultTo: [],
      subject: "",
      editorState: EditorState.createEmpty(),
      loading: false,
      listData: [],
      listDataSMS: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      showCC: false,
      showBcc: false,
      smsTemplateValue: "",
      oldSMSTemplateValue: "",
      oldEmailTemplateValue: "",
      templateIdEmail: "",
      templateIdSMS: "",
      smsButtons: [],
      showAvailabeEmailTemplates: false,
      showAvailabeSMSTemplates: false,
      emailButtons: [],
      smsResults: [],
      emailResults: [],
      loadingSendButton: {
        sms: false,
        email: false,
      },
      scrolled: false,
      isLoading: false,
      suggestion: "",
      prompt: "",
      suggestionsList: [],
      showTranscript: false,
      userScrolled: false,
      translateData: null,
      translateDataId: "",
      isOpen: [],
    };
    this.setEmail = this.props.setEmail;
    this.setAgentAssist = this.props.setAgentAssist;
    this.setSms = this.props.setSms;
    this.conversationEndRef = React.createRef();
    this.messageContainerRef = React.createRef();
  }

  // componentDidUpdate(prevProps) {
  //   // Check if the tab change (or other criteria) has occurred
  //   if (this.props.callTranscript !== prevProps.callTranscript && !this.state.scrolled) {
  //     window.scrollTo(0, 0);
  //     this.setState({ scrolled: true });
  //   }
  // }

  // handleTabClick = () => {
  //   // Scroll to the top of the page
  //   window.scrollTo(0, 0);

  //   // Reset scroll state
  //   this.setState({ scrolled: false });
  // };

  // componentDidUpdate() {
  //   const messageContainer = document.querySelector(
  //     ".contact-message-body-item"
  //   );
  //   if (messageContainer) {
  //     messageContainer.scrollTop = messageContainer.scrollHeight;
  //   }
  // }

  componentDidUpdate(prevProps) {
    // Scroll to the bottom only if user hasn't manually scrolled up
    if (this.props.callTranscript !== prevProps.callTranscript) {
      if (!this.state.userScrolled) {
        this.scrollToBottom();
      }
    }
    if (this.props.agentAssist !== prevProps.agentAssist) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    const messageContainer = this.messageContainerRef.current;
    const chatContainer = document.querySelector(".chat-container");
    if (messageContainer) {
      // Scroll to the bottom
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  handleTabClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Reset scroll state
    this.setState({ userScrolled: false });
  };

  handleScroll = () => {
    const messageContainer = this.messageContainerRef.current;
    if (messageContainer) {
      const isAtBottom =
        Math.abs(
          messageContainer.scrollHeight -
          messageContainer.scrollTop -
          messageContainer.clientHeight
        ) <= 1;

      // If user has scrolled up
      if (!isAtBottom) {
        this.setState({ userScrolled: true });
      } else {
        this.setState({ userScrolled: false }, () => {
          this.scrollToBottom(); // Ensure it scrolls to bottom if needed
        });
      }
    }
  };

  getTeam(team) {
    if (team._id) {
      return team._id;
    } else if (team.id) {
      return team.id;
    }
  }
  // getSummaryInfo(team, teamList) {
  //   let showSummaryDetails;
  //   let teamId = team && this.getTeam(team);
  //   teamList &&
  //     teamList.map((e) => {
  //       if (e.id === teamId) {
  //         if (e.summary == true) {
  //           showSummaryDetails = true;
  //         } else {
  //           showSummaryDetails = false;
  //         }
  //       }
  //     });
  // }
  getTranscriptionInfo(team, teamList) {
    let showTranscriptData;
    let showTranscript;
    let showAgentAssist;
    let teamId = team && this.getTeam(team);
    teamList &&
      teamList.map((e) => {
        if (e._id === teamId) {
          if (e.sendTranscript === true || e.agentAssist === true) {
            showTranscriptData = true;
            if (e.sendTranscript && !e.agentAssist) {
              showTranscript = true;
              showAgentAssist = false;
            } else if (e.agentAssist && !e.sendTranscript) {
              showAgentAssist = true;
              showTranscript = false;
            } else if (e.agentAssist && e.sendTranscript) {
              showAgentAssist = true;
              showTranscript = true;
            } else {
              showTranscript = false;
              showAgentAssist = false;
            }
            // this.setState({ showTranscript: true });
          } else {
            showTranscriptData = false;
            // this.setState({ showTranscript: false });
          }
        }
      });
    return { showTranscriptData, showTranscript, showAgentAssist };
  }
  
  // getTranscriptionInfo(team, teamList) {
  //   let showTranscriptData = false;
  //   let showTranscript = false;
  //   let showAgentAssist = false;

  //   if (!team || !teamList)
  //     return { showTranscriptData, showTranscript, showAgentAssist };

  //   const teamId = this.getTeam(team);

  //   teamList.forEach((e) => {
  //     if (e._id === teamId) {
  //       if (e.sendTranscript || e.agentAssist) {
  //         showTranscriptData = true;
  //         showTranscript = e.sendTranscript === true;
  //         showAgentAssist = e.agentAssist === true && !e.sendTranscript;
  //       }
  //     }
  //   });

  //   return { showTranscriptData, showTranscript, showAgentAssist };
  // }

  getEmailTemplates(team, teamList) {
    let emailList = [];
    let sendEmail;
    // let teamId = team && team._id;
    let teamId = team && this.getTeam(team);
    teamList &&
      teamList.map((e) => {
        if (e._id === teamId) {
          // this.setState({listData: e.emailTemplates})
          emailList = e.emailTemplates;
          sendEmail = e.sendEmail;
        }
      });
    return { emailList, sendEmail };
  }
  getSMSTemplates(team, teamList) {
    let smsList = [];
    let sendSms;
    let teamId = team && this.getTeam(team);
    teamList &&
      teamList.map((e) => {
        if (e._id === teamId) {
          smsList = e.smsTemplates;
          sendSms = e.sendSms;
        }
      });
    // this.setState({listDataSMS: smsList})
    return { smsList, sendSms };
  }
  // componentDidMount(){
  //   // this.getEmailProvider(
  //   //   this.state.currentPage,
  //   //   this.state.perPageCount,
  //   //   ''
  //   // );
  //   // this.getSMSProvider(
  //   //   this.state.currentPage,
  //   //   this.state.perPageCount,
  //   //   ''
  //   //   );
  //   const { team, teamList } = this.props;
  //   this.getEmailTemplates(team, teamList);
  //   this.getSMSTemplates(team, teamList);

  //   }

  getEmailProvider(page = 1, perPage = 10, searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/email-templete?limit=${perPage}&page_no=${page}&orderBy=update_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            limit: perPage,
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }
  getSMSProvider(page = 1, perPage = 10, searchText = "") {
    var that = this;
    this.setState({ loadingSMS: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/sms-templete?limit=${perPage}&page_no=${page}&orderBy=update_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loadingSMS: false });
        if (data && data.data) {
          that.setState({
            listDataSMS: data.data,
            totalSMSCount: data.count || 0,
            limitSMS: perPage,
          });
        } else {
          that.setState({ listDataSMS: [] });
        }
      },
      (error, data) => {
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  renderFormGroup(label, props) {
    return (
      <div
        style={{
          marginTop: "15px",
          padding: "0 7px",
          ...(props.buttonWidth ? { width: props.buttonWidth } : {}),
        }}
      >
        <FormGroup>
          <ControlLabel required={props.required}>{label}</ControlLabel>
          <FormControl {...props} />
        </FormGroup>
      </div>
    );
  }

  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.comments) {
      let currentComments = JSON.stringify(nextProps.comments);
      let prevComments = JSON.stringify(prevState.comments);
      if (currentComments !== prevComments) {
        let comments = nextProps.comments;
        this.setState({
          list: this.processData(comments),
        });
      }
    }
  }
  open() {
    if (this.state.isActive) {
      this.setState({ isActive: false });
    } else {
      this.setState({ isActive: true });
    }
  }
  processData(data) {
    let dateWise = {};
    data.map((el) => {
      if (el && el.Date) {
        if (!dateWise[el.Date]) {
          dateWise[el.Date] = [];
        }
        dateWise[el.Date].push(el);
      }
    });
    return dateWise;
  }
  renderTag(tags) {
    if (
      tags &&
      tags[0] &&
      tags[0][0] &&
      tags[0][0].level0 &&
      tags[0][0].level1 &&
      tags[0][0].level2
    ) {
      return `${tags[0][0].level0.name} ${tags[0][0].level1.name} ${tags[0][0].level2.name}`;
    } else if (
      tags &&
      tags[0] &&
      tags[0][0] &&
      tags[0][0].level0 &&
      tags[0][0].level1
    ) {
      return tags[0][0].level0.name + " " + tags[0][0].level1.name;
    } else if (tags && tags[0] && tags[0][0] && tags[0][0].level0) {
      return tags[0][0].level0.name;
    } else if (tags && tags[0] && tags[0][0] && tags[0][0].label) {
      return tags[0][0].label;
    } else {
      return "";
    }
  }
  getTypeUrl(type) {
    if (type == "Inbound" || type == "incomming") {
      return "/images/inbound-call.png";
    } else if (type == "Missed") {
      return "/images/missed-call.png";
    }
    return "/images/outgoing-call.png";
  }
  renderActivity(data) {
    return (
      <DataView>
        <span className="time col-md-1" style={{ marginRight: "40px" }}>
          {data.time}
        </span>
        <ContentData className="col-md-10">
          <BoxData>
            <span>
              <IconData>
                <img src={this.getTypeUrl(data.CallType)} />
              </IconData>
            </span>
            <span>
              <TagLine>
                <h6>{data.agentName}</h6>
                <span>{this.renderTag(data.tags)}</span>
              </TagLine>
              <DescData>
                <div>{data.comment}</div>
                {/* <div>Contrary to popular belief, Lorem Ipsum is not simply random text...Contrary to popular belief, Lorem Ipsum is not simply random text...
                                {this.state.isActive && 'Contrary to popular belief, Lorem Ipsum is not simply random text...'}
                                <span onClick={() => this.open()}>{!this.state.isActive ? 'see more' : 'see less'}</span>
                            </div> */}
              </DescData>
            </span>
          </BoxData>
        </ContentData>
      </DataView>
    );
  }
  renderActivityList(data) {
    return data.map((logs) => this.renderActivity(logs));
  }
  handleOnChange(value) {
    // const {setEmail} = this.props;
    let formatedDefaultBcc = [];
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value.length && !reg.test(value[value.length - 1].value)) {
      // return Alert.error(`Please enter valid email`);
      return;
    }
    // this.setState({ valueForBcc: value });
    this.setEmail({ key: "valueForBcc", value });

    value.map((e) => {
      formatedDefaultBcc.push(e.value);
    });
    // this.setState({ defaultBcc: formatedDefaultBcc });
    this.setEmail({ key: "defaultBcc", value: formatedDefaultBcc });
  }
  handleOnChangeCC(value) {
    let formatedDefaultCC = [];
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   if (value.length && !reg.test(value[value.length - 1].value)) {
      // return Alert.error(`Please enter valid email`);
      return;
    }
    // this.setState({ valueForCC: value });
    this.setEmail({ key: "valueForCC", value });
    value.map((e) => {
      formatedDefaultCC.push(e.value);
    });
    // this.setState({ defaultcc: formatedDefaultCC });
    this.setEmail({ key: "defaultcc", value: formatedDefaultCC });
  }
  handleOnChangeTo(value) {
    let formatedDefaultCC = [];
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value.length && !reg.test(value[value.length - 1].value)) {
      // return Alert.error(`Please enter valid email`);
      return;
    }
    // this.setState({ valueForTo: value });
    this.setEmail({ key: "valueForTo", value });
    value.map((e) => {
      formatedDefaultCC.push(e.value);
    });
    // this.setState({ defaultTo: formatedDefaultCC });
    this.setEmail({ key: "defaultTo", value: formatedDefaultCC });
  }
  onEditorStateChange = (editorState) => {
    // let {email}= this.props;
    // if(email.editorState.getCurrentContent().getPlainText()===" "){
    //   return;
    // }
    // this.setState({ editorState, templateIdEmail: '' });
    this.setEmail({ key: "editorState", value: editorState });
    this.setEmail({ key: "templateIdEmail", value: "" });
  };
  // insertText(text, editorValue) {
  // insertText(editorState, variable, value) {
  //   // const currentContent = editorValue.getCurrentContent();
  //   // const currentSelection = editorValue.getSelection();

  //   // const newContent = Modifier.replaceText(
  //   //   currentContent,
  //   //   currentSelection,
  //   //   text
  //   // );

  //   // const newEditorState = EditorState.push(
  //   //   editorValue,
  //   //   newContent,
  //   //   "replace-text"
  //   // );
  //   // return EditorState.forceSelection(
  //   //   newEditorState,
  //   //   newContent.getSelectionAfter()
  //   // );

  //   // const contentState = ContentState.createFromText(text);
  //   // return EditorState.push(editorValue, contentState, 'replace-content');

  //   const currentContent = editorState.getCurrentContent();
  //   let htmlPuri = draftToHtmlPuri(
  //     convertToRaw(currentContent)
  //   );
  //   const blocks = convertFromHTML(htmlPuri);
  //   const contentState = ContentState.createFromBlockArray(
  //     blocks.contentBlocks,
  //     blocks.entityMap
  //   );
  //   let temp = editorState.createWithContent(contentState)
  //   let text = currentContent.getPlainText();
  //   this.state.emailButtons.map(ele=>{
  //     htmlPuri = htmlPuri.replace(`{${ele}}`, this.state[`emailButton${ele}`]);

  //   })
  //   // const contentState = ContentState.createFromText(htmlPuri);
  //   return EditorState.push(editorState, contentState, 'replace-content');
  // };

  // insertText(editorState, variable, value) {
  //   let htmlPuri = draftToHtmlPuri(convertToRaw(this.state.editorState.getCurrentContent()));

  //   this.state.emailButtons.map(ele => {
  //     htmlPuri = htmlPuri.replace(`{${ele}}`, this.state[`emailButton${ele}`]);
  //   });
  //   const blocks = convertFromHTML(htmlPuri);
  //   const contentState = ContentState.createFromBlockArray(
  //     blocks.contentBlocks,
  //     blocks.entityMap
  //   );

  //   // const updatedContentState = convertFromHTML(htmlPuri).contentState;
  //   const updatedContentState = EditorState.createWithContent(contentState);
  //   // return EditorState.push(editorState, "<p>sdlfkj <strong>khekhekhe</strong></p>", 'replace-content');
  //   this.setState({editorState:EditorState.push(editorState, "<p>sdlfkj <strong>khekhekhe</strong></p>", 'replace-content')})
  //   // this.setState({editorState:updatedContentState})
  // };

  htmlConverter(plainHtml) {
    const html = plainHtml;
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      // this.state = {
      //   editorState
      // };
      // this.setState({editorState:editorState})
      return editorState;
    }
  }
  getTemplateBody(e) {
    const body = e.templete || "";
    // this.setState({editorState: this.htmlConverter(body),templateIdEmail: e._id, oldEmailTemplateValue: body, oldEditorState:this.htmlConverter(body)})
    this.setEmail({ key: "editorState", value: this.htmlConverter(body) });
    this.setEmail({ key: "templateIdEmail", value: e._id });
    this.setEmail({ key: "oldEmailTemplateValue", value: body });
    this.setEmail({ key: "oldEditorState", value: this.htmlConverter(body) });
    // const variables = this.getVariables(body);
    // this.setState({emailButtons:variables})
  }

  getVariables(body) {
    let variables = [];
    let match;
    const regex = /{([^{}]+)}/g;
    while ((match = regex.exec(body))) {
      variables.push(match[1]);
    }
    return variables;
  }

  getSMSTemplate(e) {
    // clear textboxes when another template is selected.
    let { sms } = this.props;
    sms.smsButtons &&
      sms.smsButtons.map((ele) => {
        // this.setState({[`smsButton${ele}`]:''})
        this.setSms({ key: `smsButton${ele}`, value: "" });
      });
    const body = e.templete || "";
    // this.setState({smsTemplateValue: body, templateIdSMS: e._id, oldSMSTemplateValue: body},
    //   ()=>{
    //   // this.textAreaRef.current.setAttribute('style', 'height:auto;');
    //   // const styles = Object.entries(this.textAreaStyle)
    //   // .map(([key, value]) => `${key}: ${value}`)
    //   // .join("; ");
    //   // this.textAreaRef.current.setAttribute('style', `${styles}; height:${this.textAreaRef.current.scrollHeight + 30}px;`);

    // }
    // )
    this.setSms({ key: "smsTemplateValue", value: body });
    this.setState({ smsTemplateValue: body });
    this.setSms({ key: "templateIdSMS", value: e._id });
    this.setSms({ key: "oldSMSTemplateValue", value: body });
    const variables = this.getVariables(body);
    this.setState({ smsButtons: variables });
    this.setSms({ key: "smsButtons", value: variables });
  }
  search(e, emailList) {
    let value;
    let list = [];
    value = e.target.value;
    this.setState({ searchValue: value });
    emailList &&
      emailList.map((e) => {
        if (e.name && e.name.toLowerCase().includes(value.toLowerCase())) {
          list.push(e);
        }
      });
    this.setState({ emailResults: list });
    return list;
    // this.setState({ search: value });
    // if (this.timer) clearTimeout(this.timer);
    // this.timer = setTimeout(() => {
    //   this.getEmailProvider(1, '', this.state.search);
    // }, 500);
  }
  searchSMS(e, smsList) {
    let value;
    let list = [];
    value = e.target.value;
    this.setState({ searchValueSMS: value });
    smsList &&
      smsList.map((e) => {
        if (e.name && e.name.toLowerCase().includes(value.toLowerCase())) {
          list.push(e);
        }
      });
    this.setState({ smsResults: list });
    // if (this.timer) clearTimeout(this.timer);
    // this.timer = setTimeout(() => {
    //   this.getSMSProvider(1, '', this.state.searchValueSMS);
    // }, 500);
  }
  clearEmailStates() {
    // this.setState({
    //   valueForBcc: [],
    //   valueForCC: [],
    //   valueForTo: [],
    //   defaultTo: [],
    //   defaultBcc: [],
    //   defaultcc: [],
    //   subject: "",
    //   editorState: EditorState.createEmpty(),
    // })
    this.setEmail({ key: "valueForBcc", value: [] });
    this.setEmail({ key: "valueForCC", value: [] });
    this.setEmail({ key: "valueForTo", value: [] });
    this.setEmail({ key: "defaultTo", value: [] });
    this.setEmail({ key: "defaultBcc", value: [] });
    this.setEmail({ key: "defaultcc", value: [] });
    this.setEmail({ key: "subject", value: "" });
    this.setEmail({ key: "editorState", value: EditorState.createEmpty() });
  }
  clearSMSStates() {
    let { sms } = this.props;
    // this.state.smsButtons && this.state.smsButtons.map(ele=>{
    //   this.setState({[`smsButton${ele}`]:''})
    // })
    sms.smsButtons &&
      sms.smsButtons.map((ele) => {
        this.setSms({ key: `smsButton${ele}`, value: "" });
      });
    // this.state.smsButtons && this.setState({smsButtons:[]})
    sms.smsButtons && this.setSms({ key: "smsButtons", value: [] });
    // this.setState({
    //   smsTemplateValue: "",
    //   templateIdSMS: "",
    // })
    this.setSms({ key: "smsTemplateValue", value: "" });
    this.setSms({ key: "templateIdSMS", value: "" });
  }
  handleReset(eventKey) {
    // const {setActiveTab}= this.props;
    // if(eventKey === 2){
    //   this.clearSMSStates();
    // }
    // else if(eventKey === 3){
    //   this.clearEmailStates();
    // }
    // else{
    //   this.clearEmailStates();
    //   this.clearSMSStates();
    // }
    // if(eventKey===1){
    // setActiveTab(eventKey)
    // }
  }
  componentWillUnmount() {
    this.clearEmailStates();
    this.clearSMSStates();
  }
  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
    }
  }
  send(url) {
    let tData = {};
    const { customerNumber, callTeam } = this.props;
    if (url === "sms") {
      if (!customerNumber) {
        return Alert.error("Number is not available.");
      }
      if (!this.state.smsTemplateValue) {
        return Alert.error("Message should not be empty.");
      }
      tData = {
        teamId: callTeam._id || "",
        message: this.state.smsTemplateValue || "",
        value: {},
        templeteId: this.props.sms.templateIdSMS || "",
        to: customerNumber,
      };
      // this.clearSMSStates();
    }
    if (url === "email") {
      const { email } = this.props;
      const htmlPuri = draftToHtmlPuri(
        convertToRaw(
          email && email.editorState && email.editorState.getCurrentContent()
        )
      );
      // if(!htmlPuri){
      //   return Alert.error("Body should not be empty.")
      // }
      if (!email.editorState.getCurrentContent().getPlainText()) {
        return Alert.error("Body should not be empty.");
      }
      if (!email.subject) {
        return Alert.error("Subject should not be empty.");
      }
      if (email.defaultTo && email.defaultTo.length === 0) {
        return Alert.error("To field should not be empty.");
      }
      tData = {
        teamId: callTeam._id || "",
        value: {},
        // "templeteId": this.state.templateIdEmail || "",
        templeteId: email.templateIdEmail || "",
        type: "custom",
        subject: email.subject || "",
        to: email.defaultTo || [],
        cc: email.defaultcc || [],
        bcc: email.defaultBcc || [],
        values: {},
        html: htmlPuri || "",
      };
    }
    let _this = this;
    if (url === "sms") {
      this.setState({
        loadingSendButton: {
          ...this.state.loadingSendButton,
          sms: true,
        },
      });
    } else if (url === "email") {
      this.setState({
        loadingSendButton: {
          ...this.state.loadingSendButton,
          email: true,
        },
      });
    }
    // this.setState({loadingSendButton: true})
    this.mAPI.sendPostAPI(
      `tenant/${url}/send`,
      tData,
      (data) => {
        this.setState({
          loadingSendButton: {
            email: true,
            sms: true,
          },
        });
        if (url === "email") {
          this.clearEmailStates();
        } else if (url === "sms") {
          this.clearSMSStates();
        }
        if (data) {
          // _this.resetAllData();
          // _this.props.closeModal(true);
          // Alert.success(`Name ${tData.name} is Updated.`);
          if (data.status === 200) {
            Alert.success(
              url === "sms"
                ? "Sms sent successfully."
                : "Email sent successfully."
            );
          }
        }
      },
      (errorCode, data) => {
        this.setState({
          loadingSendButton: {
            email: true,
            sms: true,
          },
        });
        this.apiResponse(errorCode, data);
      },
      "private",
      { id: tData._id },
      "PATCH"
    );
  }
  renderButton({ content, ...props }) {
    return <Button {...props}>{content}</Button>;
  }
  renderSendButton(url) {
    let { sms } = this.props;
    return (
      <div
        style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
      >
        {sms.smsTemplateValue &&
          sms.smsTemplateValue.length > 0 &&
          // this.renderButton('Clear',{
          //   bgColor:'red',
          //   className:'mr-3',
          //   onClick:()=>this.clearSMSStates()
          // })
          this.renderButton({
            content: <div>Clear</div>,
            bgColor: "red",
            className: "mr-3",
            onClick: () => this.clearSMSStates(),
          })}
        {/* {this.renderButton(`${this.state.loadingSendButton?(
        <Spinner objective={true}/>
        ):<div>'Send'</div>}
        `,{
          bgColor:'blue',
          onClick:()=>this.send(url)
        })} */}
        {url === "sms"
          ? this.renderButton({
            content: this.state.loadingSendButton.sms ? (
              <Spinner
                style={{ height: "23px", marginTop: "0px", width: "85px" }}
                objective={true}
              />
            ) : (
              <div>Send</div>
            ),
            bgColor: "blue",
            onClick: () => {
              !this.state.loadingSendButton.sms && this.send(url);
            },
          })
          : this.renderButton({
            content: this.state.loadingSendButton.email ? (
              <Spinner
                style={{ height: "23px", marginTop: "0px", width: "85px" }}
                objective={true}
              />
            ) : (
              <div>Send</div>
            ),
            bgColor: "blue",
            onClick: () => {
              !this.state.loadingSendButton.email && this.send(url);
            },
          })}
        {/* {this.renderButton({
          content: this.state.loadingSendButton?<Spinner style={{height:'23px',marginTop:'0px',width:'85px'}} objective={true}/>:<div>Send</div>,
          bgColor:'blue',
          onClick:()=>{
            !this.state.loadingSendButton && this.send(url)
          }
        })} */}
      </div>
    );
  }
  replaceVar(type, variable, value) {
    if (type === "sms") {
      let { sms } = this.props;
      let temp = this.state.oldSMSTemplateValue;
      this.state.smsButtons &&
        this.state.smsButtons.map((ele) => {
          temp = temp.replace(
            new RegExp(`\\{${ele}\\}`, "g"),
            this.state[`smsButton${ele}`]
              ? this.state[`smsButton${ele}`]
              : `{${ele}}`
          );
        });
      let temp1 = sms.oldSMSTemplateValue;
      sms.smsButtons &&
        sms.smsButtons.map((ele) => {
          temp1 = temp1.replace(
            new RegExp(`\\{${ele}\\}`, "g"),
            sms[`smsButton${ele}`] ? sms[`smsButton${ele}`] : `{${ele}}`
          );
        });
      this.setState({ smsTemplateValue: temp1 });
      this.setSms({ key: "smsTemplateValue", value: temp1 });
    } else if (type === "email") {
      // this.setState({editorState :this.insertText('helllllooo',this.state.editorState)})
      // let temp = this.state.oldEmailTemplateValue;
      // this.setState({editorState :this.insertText(this.state.editorState, variable, value)})
      // this.setState({editorState :this.insertText(this.state.oldEditorState, variable, value)})
      // this.setState({editorState :this.insertText(this.state.oldEditorState, variable, value)})
      // this.insertText()
      // let temp = this.state.oldEmailTemplateValue;
      // this.state.emailButtons && this.state.emailButtons.map(ele=>{
      //   temp = temp.replace(new RegExp(`\\{${ele}\\}`, 'g'), this.state[`emailButton${ele}`]?this.state[`emailButton${ele}`]:`{${ele}}`);
      // });
      // this.setState({emailTemplateValue: temp});
    }
  }
  renderHeader(header) {
    return <UserName style={{ marginBottom: "15px" }}>{header}</UserName>;
  }
  renderSearch({ ...props }) {
    return (
      <SeachForm>
        <FormControl
          style={{ marginBottom: "15px" }}
          type="text"
          placeholder={"Search..."}
          autoFocus={false}
          {...props}
        />
      </SeachForm>
    );
  }
  renderGreyText(content, { ...props }) {
    return <GreyText {...props}>{content}</GreyText>;
  }
  // renderMoreButton(tabName){
  //   return (
  //       <div
  //         style={{ color: "blue", cursor: "pointer", marginLeft: "16px",  }}
  //         onClick={(e) => {
  //           e.preventDefault();
  //           if(tabName === 'email'){
  //             this.getEmailProvider(1, this.state.limit+10, this.state.search);
  //           }
  //           else if(tabName === 'sms'){
  //             this.getSMSProvider(1, this.state.limitSMS+10, this.state.searchValueSMS);
  //           }
  //         }}
  //       >
  //         more...
  //       </div>

  //   )
  // }
  renderCreatable(label, props) {
    return (
      <FormGroup style={{ padding: "0 7px" }}>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <Select.Creatable {...props} />
      </FormGroup>
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Successfully Done";
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  resetAllData() {
    this.setState({
      prompt: "",
    });
  }

  getConversationId() {
    const answer = this.props.agentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const conversationData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.conversationId
      );

      return conversationData
        ? conversationData &&
        conversationData.meta &&
        conversationData.meta.conversationId
        : "";
    }

    return "";
  }

  getSessionId() {
    const answer = this.props.agentAssist.find((item) => item.key === "Answer");

    if (answer && Array.isArray(answer.value)) {
      const sessionData = answer.value.find(
        (val) => val.type === "text" && val.meta && val.meta.sessionId
      );

      return sessionData
        ? sessionData && sessionData.meta && sessionData.meta.sessionId
        : "";
    }

    return "";
  }

  saveData(e) {
    e.preventDefault();
    let _this = this;

    _this.resetAllData();
    this.setState({ isLoading: true });

    if (!this.state.prompt || this.state.prompt.trim() === "") {
      this.setState({ isLoading: false });
      return Alert.error("Enter Data");
    }

    let suggestion = this.state.prompt || "";
    suggestion = suggestion.trim();
    this.props.setAgentAssist({ key: "Question", value: suggestion });
    const conversationId = this.getConversationId();
    const sessionId = this.getSessionId();
    // let tData = {
    //   suggestion: suggestion,
    // };
    this.mAPI.sendPostAPI(
      `/agent-response`,
      {
        teamId: this.props.callTeam.id,
        meta: {
          conversationId: conversationId || "",
          sessionId: sessionId || "",
        },
        slots: (this.props.callInfo && this.props.callInfo.slots) || [],
        prompt: suggestion,
      },
      (data) => {
        if (data) {
          _this.resetAllData();
          this.state.suggestionsList = data;
          this.props.setAgentAssist({ key: "Answer", value: data });

          // dispatch(
          //   chatAction.dynamicUpdate({
          //     data: { key: "agentAssist", value: data },
          //   })
          // );
          // Alert.success(`${data.message}`);
        } else {
          this.props.setAgentAssist({
            key: "Answer",
            value: [
              {
                type: "text",
                content: "Something went wrong",
                method: "error",
              },
            ],
          });
          // Alert.error("Something went wrong");
          // Alert.success(`Successfully Added`);
        }
        this.setState({ isLoading: false });
      },
      (errorCode, data) => {
        this.setState({ isLoading: false });
        // this.apiResponse(errorCode, data);
        if (errorCode === 201) {
          // Alert.success(`${data.message}`);
          let message =
            data && data.message ? data.message : "Successfully Done";
          Alert.success(`${message}`);
          this.resetAllData();
        } else {
          // Alert.error(`${data.message}`);
          let message =
            data && data.message ? data.message : "Something wrong happened";
          this.props.setAgentAssist({
            key: "Answer",
            value: [
              {
                type: "text",
                content: message,
                method: "error",
              },
            ],
          });
          Alert.error(message);
        }
      }
    );
  }

  // renderSuggestData(message) {
  //   // this.setState({ isLoading: true });
  //   // this.mAPI.sendPostAPI(
  //   //   `/agent-response`,
  //   //   {
  //   //     teamId: this.props.callTeam.id,
  //   //     prompt: message,
  //   //   },
  //   //   (data) => {
  //   //     if (data) {
  //   //       this.state.suggestionsList = data;
  //   //       // Alert.success(`${data.message}`);
  //   //     } else {
  //   //       Alert.success(`Successfully Added`);
  //   //     }
  //   //     // this.setState({ isLoading: false });
  //   //   },

  //   //   (errorCode, data) => {
  //   //     // this.setState({ isLoading: false });
  //   //     this.apiResponse(errorCode, data);
  //   //   }
  //   // );
  // }

  renderSuggestData(message) {
    // this.resetAllData();
    if (message) {
      this.setState({
        isLoading: true,
      });

      let suggestion = message.trim() || "";
      suggestion = suggestion.trim();
      this.props.setAgentAssist({ key: "Question", value: suggestion });
      const conversationId = this.getConversationId();
      const sessionId = this.getSessionId();
      this.mAPI.sendPostAPI(
        `/agent-response`,
        {
          teamId: this.props.callTeam.id,
          prompt: message.trim(),
          meta: {
            conversationId: conversationId || "",
            sessionId: sessionId || "",
          },
          slots: (this.props.callInfo && this.props.callInfo.slots) || [],
        },
        (data) => {
          if (data) {
            // this.resetAllData();
            this.state.suggestionsList = data;
            this.props.setAgentAssist({ key: "Answer", value: data });
            // this.state.suggestionsList = data;
            // Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.setState({ isLoading: false });
        },

        (errorCode, data) => {
          this.setState({ isLoading: false });
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  onTranslate(index, message) {
    let tData = {
      text: message && message.content && message.content.text,
      targetLanguage: "en",
    };

    this.mAPI.sendPostAPI(
      "translate",
      tData,
      (data) => {
        if (data) {
          // Alert.success(`${data.message}`);
          // setTranslateData(data.data);
          this.setState({ translateData: data.data, translateDataId: index });
          this.props.updateTranslateCall(index, data.data);
        } else {
          Alert.success(`Successfully Added`);
        }
        // this.resetAllData();
        // this.props.update();
        // this.props.closeModal(true);
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      }
    );
  }

  clearChat = () => {
    this.props.clearAgentAssist(); // Clear the agentAssist using Redux
  };

  handleDelete = (index) => {
    // Logic to handle deletion
  };

  toggleAccordion = (index) => {
    this.setState((prevState) => {
      // Check if the current index is already open
      const isOpen = prevState.isOpen.includes(index);

      // If it's already open, filter it out (close it), otherwise add it to the array (open it)
      const updatedIsOpen = isOpen
        ? prevState.isOpen.filter((i) => i !== index)
        : [...prevState.isOpen, index];

      return { isOpen: updatedIsOpen };
    });
  };

  render() {
    const {
      team,
      teamList,
      sms,
      email,
      activeTab,
      callTeam,
      callTranscript,
      messageList,
      callTagList,
      agentAssist,
      callInfo,
      summary,
    } = this.props;

    // let { showSummaryDetails } = this.getSummaryInfo(callTeam, teamList);

    // const isCallTagListBlank = !callTagList || callTagList.length === 0;
    // const updatedCallTranscript = isCallTagListBlank ? "" : callTranscript;

    let {
      showTranscriptData,
      showTranscript,
      showAgentAssist,
    } = this.getTranscriptionInfo(callTeam, teamList);
    let { emailList, sendEmail } = this.getEmailTemplates(callTeam, teamList);
    let { smsList, sendSms } = this.getSMSTemplates(callTeam, teamList);
    const mainContent = (
      // <div>
      //   {this.state.listData && this.state.listData.map(e=>(
      //       <Label onClick={()=>this.getTemplateBody(e)}>{e.name}</Label>
      //   ))}
      // {this.state.listData && this.state.listData.length<10?'':this.renderMoreButton('email')}
      // </div>
      <div>
        {emailList &&
          emailList.map((e) => (
            <Label onClick={() => this.getTemplateBody(e)}>{e.name}</Label>
          ))}
        {/* {emailList && emailList.length<10?'':this.renderMoreButton('email')} */}
      </div>
    );
    const searchEmailList = (
      <div>
        {this.state.emailResults &&
          this.state.emailResults.length === 0 &&
          `No results found for "${this.state.searchValue}"`}
        {this.state.emailResults &&
          this.state.emailResults.map((e) => (
            <Label onClick={() => this.getTemplateBody(e)}>{e.name}</Label>
          ))}
        {/* {this.state.emailResults && this.state.emailResults.length<10?'':this.renderMoreButton('email')} */}
      </div>
    );
    const SMSList = (
      // <div>
      //   {this.state.listDataSMS && this.state.listDataSMS.map(e=>(
      //       <Label onClick={()=>this.getSMSTemplate(e)}>{e.name}</Label>
      //   ))}
      //   {this.state.listDataSMS && this.state.listDataSMS.length<10?'':this.renderMoreButton('sms')}
      // </div>
      <div>
        {smsList &&
          smsList.map((e) => (
            <Label onClick={() => this.getSMSTemplate(e)}>{e.name}</Label>
          ))}
        {/* {smsList && smsList.length<10?'':this.renderMoreButton('sms')} */}
      </div>
    );
    const searchSMSList = (
      <div>
        {this.state.smsResults &&
          this.state.smsResults.length === 0 &&
          `No results found for "${this.state.searchValueSMS}"`}
        {this.state.smsResults &&
          this.state.smsResults.map((e) => (
            <Label onClick={() => this.getSMSTemplate(e)}>{e.name}</Label>
          ))}
        {/* {this.state.smsResults && this.state.smsResults.length<10?'':this.renderMoreButton('sms')} */}
      </div>
    );
    const getRole = (message) => {
      if (message.from) return message.from;
      return "customer";
    };

    const userDetails = {};
    const longValueDetails = {};

    Object.keys(summary).forEach((key) => {
      if (key.startsWith("static__")) {
        const newKey = key.replace("static__", ""); // Remove 'static__' prefix
        const value = summary[key];

        // Check if value is long
        if (value.length > 15) {
          longValueDetails[newKey] = value; // Store long value
        } else {
          userDetails[newKey] = value; // Store normal value
        }
      }
    });

    let _this = this;

    return (
      <DataWrapperClass style={{ overflowX: "hidden" }}>
        <InsightRow removeMarginZero={true} className="h-100">
          <Row className="h-100 w-100">
            <Col
              md={showAgentAssist ? 8 : 12}
              style={{
                borderRight: "1px solid #ddd",
                paddingRight: "0px",
                paddingLeft: "0px",
              }}
            >
              <TabItemsStyle>
                <div className="tabItemStyle h-100">
                  <Tabs
                    className="liveMonitorTabs"
                    onSelect={(eventKey) => this.handleReset(eventKey)}
                    // style={{ marginTop: "15px", marginLeft: "15px" }}
                    defaultActiveKey={activeTab}
                    id="uncontrolled-tab-example"
                  >
                    <Tab eventKey={1} title="Activity Timeline">
                      <UserName style={{ padding: "20px" }}>
                        Activity Timeline
                      </UserName>
                      <ComponentBox
                      // style={{ width: "100%", height: "calc(100vh - 250px)" }}
                      >
                        {Object.keys(this.state.list).length === 0 &&
                          "No call logs found"}
                        {this.state.list &&
                          Object.keys(this.state.list).map(function (key) {
                            return (
                              <span>
                                <DateView>
                                  <span className="date">{key}</span>
                                  <hr />
                                </DateView>
                                {_this.renderActivityList(
                                  _this.state.list[key]
                                )}
                              </span>
                            );
                          })}
                      </ComponentBox>
                    </Tab>
                    {showTranscriptData && (
                      <Tab
                        eventKey={2}
                        title="Transcript"
                        onClick={this.handleTabClick}
                      >
                        <Row className="w-100 h-100 m-0">
                          <Col
                            md={12}
                            className="p-0"
                            style={
                              {
                                // borderRight: "1px solid rgb(226, 232, 239)",
                              }
                            }
                          >
                            {showTranscript ? (
                              <div>
                                <div
                                  className="contact-message-body-item"
                                  onScroll={this.handleScroll} // Add scroll event listener
                                  ref={this.messageContainerRef} // Reference for scrolling
                                >
                                  {callTranscript.length !== 0 ? (
                                    callTranscript.map((data, i) => {
                                      const message = data;
                                      if (!message) {
                                        return null;
                                      }
                                      if (
                                        message &&
                                        message.from === "system"
                                      ) {
                                        return <div></div>;
                                      }
                                      return (
                                        <div
                                          key={i}
                                          className={`contact-message-body-item__main contact-message-body-item__${getRole(
                                            message
                                          )}`}
                                        >
                                          <div className="position-relative">
                                            <RenderInitials
                                              text={getNameCall(data)}
                                              type={getPlatform(data)}
                                            />
                                          </div>
                                          <div
                                            className={`contact-message-body-item__inner contact-message-body-item__${getRole(
                                              message
                                            )}-bubble`}
                                          >
                                            <p
                                              className="contact-msg"
                                              style={{
                                                whiteSpace: "pre-wrap",
                                                margin: "0px",
                                              }}
                                            >
                                              {message.content.text}
                                            </p>
                                            {/* {this.state.translateDataId ===
                                              message.id &&
                                              this.state.translateData && (
                                                <div className="message-translate">
                                                  <div className="d-flex align-items-center mt-1">
                                                    <span class="material-symbols-outlined mr-2">
                                                      translate
                                                    </span>
                                                    <span>Translated</span>
                                                  </div>
                                                  <p
                                                    className="msg"
                                                    style={{
                                                      whiteSpace: "pre-wrap",
                                                      margin: "0px",
                                                    }}
                                                  >
                                                    {this.state.translateData}
                                                  </p>
                                                </div>
                                              )} */}
                                            {message.content.translate && (
                                              <div className="message-translate">
                                                <div className="d-flex align-items-center mt-1">
                                                  <span className="material-symbols-outlined mr-2">
                                                    translate
                                                  </span>
                                                  <span>Translated</span>
                                                </div>
                                                <p
                                                  className="msg"
                                                  style={{
                                                    whiteSpace: "pre-wrap",
                                                    margin: "0px",
                                                  }}
                                                >
                                                  {message.content.translate}
                                                </p>
                                              </div>
                                            )}
                                            {/* <div className="message-info-td">
                                              <span
                                                class="material-symbols-outlined message-copy"
                                                onClick={() => {
                                                  if (message.content.text) {
                                                    navigator.clipboard.writeText(
                                                      message.content.text
                                                    );
                                                    Alert.success(
                                                      "Message copied successfully"
                                                    );
                                                  } else {
                                                    Alert.error(
                                                      "Message not copy"
                                                    );
                                                  }
                                                }}
                                              >
                                                content_copy
                                              </span>
                                              <FaWandMagicSparkles
                                                style={{
                                                  fontSize: "16px",
                                                  display: "block",
                                                }}
                                                className="message-suggest"
                                                onClick={() =>
                                                  this.renderSuggestData(
                                                    message.content.text
                                                  )
                                                }
                                              />
                                            </div> */}
                                          </div>
                                          <div className="dropdown-section">
                                            <CustomDropdown
                                            // totalLength={this.state.listData.length || 0}
                                            >
                                              <MenuItem
                                                style={{ marginLeft: "0px" }}
                                                onClick={() => {
                                                  if (
                                                    message &&
                                                    message.content
                                                  ) {
                                                    navigator.clipboard.writeText(
                                                      message.content.text
                                                    );
                                                    Alert.success(
                                                      "Message copied successfully"
                                                    );
                                                  } else {
                                                    Alert.error(
                                                      "Message not copy"
                                                    );
                                                  }
                                                }}
                                              >
                                                {"Copy"}
                                              </MenuItem>
                                              <MenuItem
                                                style={{ marginLeft: "0px" }}
                                                onClick={() =>
                                                  this.renderSuggestData(
                                                    message.content.text
                                                  )
                                                }
                                              >
                                                {"Suggestion"}
                                              </MenuItem>
                                              <MenuItem
                                                style={{ marginLeft: "0px" }}
                                                onClick={() =>
                                                  this.onTranslate(
                                                    message.id,
                                                    message
                                                  )
                                                }
                                              >
                                                {"Translate"}
                                              </MenuItem>
                                            </CustomDropdown>
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <EmptyStateStyled>
                                      <img src="/images/empty/no_transcript.png" />
                                      <span>No Data Found</span>
                                    </EmptyStateStyled>
                                  )}
                                </div>
                                <div ref={this.conversationEndRef} />
                              </div>
                            ) : (
                              <div style={{}}>
                                <Header className="m-0 text-center">
                                  Your Transcription feature is off.
                                </Header>
                              </div>
                            )}
                          </Col>
                          {/* {showAgentAssist ? (
                        <Col md={4} className="p-3 chat-main-container">
                          {agentAssist && (
                            <ul className="suggestionBox chat-container">
                              {agentAssist.map((item, index) => (
                                <div
                                  key={index}
                                  className={`chat-row ${
                                    item.key === "Question"
                                      ? "question"
                                      : "answer"
                                  }`}
                                >
                                  {item.key === "Question" && (
                                    <li
                                      className="chat-bubble question-bubble"
                                      key={index}
                                    >
                                      {" "}
                                      {item.value}
                                    </li>
                                  )}
                                  {item.key === "Answer" && (
                                    <div className="chat-bubble answer-bubble">
                                      {item.value.map((answer, idx) => (
                                        <li key={idx}>
                                          {" "}
                                          {answer.type === "text" &&
                                            answer.content}
                                        </li>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </ul>
                          )}
                          <form onSubmit={(e) => this.saveData(e)}>
                            <FormWrapper>
                              <FormGroup className="w-100">
                                <div
                                  className="d-flex align-items-center"
                                  style={{ gap: "10px" }}
                                >
                                  <FormControl
                                    type="text"
                                    placeholder={"Type to search"}
                                    onChange={(e) =>
                                      this.setState({ prompt: e.target.value })
                                    }
                                    value={this.state.prompt}
                                  />

                                  <ButtonCommonTheme
                                    type="blueModalBtn"
                                    btnType="submit"
                                    btnStyle="default"
                                    className=""
                                    size="small"
                                    isLoading={this.state.isLoading}
                                  >
                                    <FaWandMagicSparkles
                                      style={{
                                        fontSize: "16px",
                                        display: "block",
                                      }}
                                    />
                                  </ButtonCommonTheme>
                                </div>
                              </FormGroup>
                            </FormWrapper>
                          </form>
                        </Col>
                      ) : (
                        ""
                      )} */}
                        </Row>
                      </Tab>
                    )}

                    <Tab
                      eventKey={3}
                      title="Summary"
                      onClick={this.handleTabClick}
                    >
                      {/* <UserName style={{ padding: "20px" }}>Title</UserName> */}
                      <div
                        style={{
                          padding: "20px",
                          height: "calc(100vh - 125px)",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {Object.keys(summary).length !== 0 ? (
                          <SummarySectionComponent
                            summary={summary}
                            userDetails={userDetails}
                            longValueDetails={longValueDetails}
                          />
                        ) : (
                          <EmptyStateStyled>
                            <img src="/images/empty/no_transcript.png" />
                            <span>No Data Found</span>
                          </EmptyStateStyled>
                        )}
                      </div>
                      {/* Tags */}
                    </Tab>

                    {sendEmail && (
                      <Tab eventKey={4} title="Email">
                        <div style={{ padding: "20px" }}>
                          <Row>
                            <Col
                              md={email.showAvailabeEmailTemplates ? 7 : 12}
                              style={{ maxWidth: "95%" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {this.renderHeader("Email page")}
                                <div style={{ display: "flex" }}>
                                  {this.renderGreyText("Cc", {
                                    isSelected: email.showCC,
                                    onClick: () => {
                                      // this.setState({showCC: !this.state.showCC},
                                      // ()=>this.state.showCC===false?this.setState({valueForCC:[],defaultcc:[]}):''
                                      // )
                                      this.setEmail({
                                        key: "showCC",
                                        value: !email.showCC,
                                      });
                                      if (email.showCC === false) {
                                        this.setEmail({
                                          key: "defaultcc",
                                          value: [],
                                        });
                                        this.setEmail({
                                          key: "valueForCC",
                                          value: [],
                                        });
                                      }
                                    },
                                  })}
                                  {this.renderGreyText("Bcc", {
                                    onClick: () => {
                                      // this.setState({showBcc: !this.state.showBcc},
                                      // ()=>this.state.showBcc===false?this.setState({valueForBcc:[],defaultBcc:[]}):''
                                      // )
                                      this.setEmail({
                                        key: "showBcc",
                                        value: !email.showBcc,
                                      });
                                      if (email.showBcc === false) {
                                        this.setEmail({
                                          key: "defaultBcc",
                                          value: [],
                                        });
                                        this.setEmail({
                                          key: "valueForBcc",
                                          value: [],
                                        });
                                      }
                                    },
                                    isSelected: email.showBcc,
                                    className: "ml-3",
                                  })}
                                  {this.renderGreyText(
                                    `${email.showAvailabeEmailTemplates
                                      ? "Hide"
                                      : "Show"
                                    } Templates`,
                                    {
                                      isSelected:
                                        email.showAvailabeEmailTemplates,
                                      onClick: () => {
                                        // this.setState({showAvailabeEmailTemplates:!this.state.showAvailabeEmailTemplates})
                                        this.setEmail({
                                          key: "showAvailabeEmailTemplates",
                                          value: !email.showAvailabeEmailTemplates,
                                        });
                                      },
                                      className: "ml-3",
                                    }
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  height: "calc(100vh - 238px)",
                                  overflow: "auto",
                                  paddingRight: "17px",
                                  paddingTop: "6px",
                                }}
                              >
                                <FormWrapper>
                                  <FormColumn>
                                    {this.renderCreatable("To", {
                                      required: true,
                                      key: `AgentList`,
                                      placeholder: "To",
                                      // value:this.state.valueForTo,
                                      value: email.valueForTo,
                                      onChange: this.handleOnChangeTo.bind(
                                        this
                                      ),
                                      multi: true,
                                    })}
                                    {email.showCC &&
                                      this.renderCreatable("cc", {
                                        key: `AgentList`,
                                        placeholder: "Cc",
                                        // value:this.state.valueForCC,
                                        value: email.valueForCC,
                                        onChange: this.handleOnChangeCC.bind(
                                          this
                                        ),
                                        multi: true,
                                      })}
                                    {email.showBcc &&
                                      this.renderCreatable("Bcc", {
                                        key: `AgentList`,
                                        placeholder: "Bcc",
                                        // value:this.state.valueForBcc,
                                        value: email.valueForBcc,
                                        onChange: this.handleOnChange.bind(
                                          this
                                        ),
                                        multi: true,
                                      })}
                                    {this.renderFormGroup("Subject", {
                                      defaultValue: "",
                                      placeholder: "Subject",
                                      autoFocus: true,
                                      required: true,
                                      id: "Subject",
                                      // value: this.state.subject,
                                      value: email.subject,
                                      onChange: (e) => {
                                        if (e.target && e.target.value) {
                                          if (e.target.value === " ") {
                                            return;
                                          } else {
                                            // this.setState({ subject: e.target.value });
                                            this.setEmail({
                                              key: "subject",
                                              value: e.target.value,
                                            });
                                          }
                                        } else {
                                          // this.setState({ subject: "" });
                                          this.setEmail({
                                            key: "subject",
                                            value: "",
                                          });
                                        }
                                      },
                                    })}
                                    <EditorCSS>
                                      <FormGroup>
                                        <ControlLabel>{"Body"}</ControlLabel>
                                        <Editor
                                          // editorState={this.state.editorState}
                                          editorState={email.editorState}
                                          onEditorStateChange={
                                            this.onEditorStateChange
                                          }
                                        />
                                      </FormGroup>
                                    </EditorCSS>
                                    {/* <SMForm>
                            {this.state.emailButtons && this.state.emailButtons.map(ele=>
                              {
                                return this.renderFormGroup(ele, {
                                  buttonWidth:'50%',
                                  defaultValue: "",
                                  placeholder: `${ele}`,
                                  // autoFocus: true,
                                  required: true,
                                  id: "To",
                                  // value: this.state.ele,
                                  // value: eval(`this.state.smsButton${ele}`)?eval(`this.state.smsButton${ele}`) : '',
                                  value: this.state[`emailButton${ele}`]?this.state[`emailButton${ele}`] : '',
                                  onChange: (e) => {
                                    if (e.target && e.target.value) {
                                      this.setState({ [`emailButton${ele}`]: e.target.value },()=>{
                                        this.replaceVar('email',ele,this.state[`emailButton${ele}`]);
                                      });
                                    } else {
                                      this.setState({ [`emailButton${ele}`]: "" },()=>{
                                        this.replaceVar('email',ele,"");
                                      });
                                    }
                                  },
                              })
                              }
                            )}
                          </SMForm> */}
                                  </FormColumn>
                                </FormWrapper>
                                {this.renderSendButton("email")}
                              </div>
                            </Col>
                            <Col
                              md={email.showAvailabeEmailTemplates ? 5 : 0}
                              style={{
                                width: "39%",
                                display: email.showAvailabeEmailTemplates
                                  ? ""
                                  : "none",
                              }}
                            >
                              {this.renderHeader("Available Templates")}
                              {this.renderSearch({
                                onChange: (e) => this.search(e, emailList),
                                value: this.state.searchValue,
                              })}
                              <div
                                className="mt-3"
                                style={{
                                  height: "calc(100vh - 280px)",
                                  overflow: "auto",
                                  wordWrap: "break-word",
                                }}
                              >
                                {/* <DataWithLoader
                          data={mainContent}
                          loading={this.state.loading}
                          size={this.state.listData.length}
                          count={this.state.listData.length}
                          emptyText="No Template Found."
                          // emptyImage="/images/emptySIP.png"
                        /> */}
                                {this.state.searchValue
                                  ? searchEmailList
                                  : mainContent}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Tab>
                    )}
                    {sendSms && (
                      <Tab eventKey={5} title="SMS">
                        <div style={{ padding: "20px" }}>
                          <Row>
                            <Col
                              md={sms.showAvailabeSMSTemplates ? 7 : 12}
                              style={{ maxWidth: "95%" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {this.renderHeader("SMS Page")}
                                <div style={{ display: "flex" }}>
                                  {this.renderGreyText(
                                    `${sms.showAvailabeSMSTemplates
                                      ? "Hide"
                                      : "Show"
                                    } Templates`,
                                    {
                                      isSelected: sms.showAvailabeSMSTemplates,
                                      onClick: () => {
                                        this.setState({
                                          showAvailabeSMSTemplates: !this.state
                                            .showAvailabeSMSTemplates,
                                        });
                                        this.setSms({
                                          key: "showAvailabeSMSTemplates",
                                          value: !sms.showAvailabeSMSTemplates,
                                        });
                                      },
                                    }
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  height: "calc(100vh - 238px)",
                                  overflow: "auto",
                                  paddingRight: "17px",
                                  paddingTop: "6px",
                                }}
                              >
                                <FormWrapper>
                                  <FormColumn>
                                    <FormGroup>
                                      <ControlLabel required={true}>
                                        {"Template"}
                                      </ControlLabel>
                                      <textarea
                                        style={this.textAreaStyle}
                                        ref={this.textAreaRef}
                                        key={`AgentList`}
                                        placeholder={"Template"}
                                        disabled={
                                          sms.templateIdSMS ? true : false
                                        }
                                        value={sms.smsTemplateValue}
                                        onChange={(e) => {
                                          if (e.target.value === " ") {
                                            return;
                                          }
                                          if (
                                            smsCounter(e.target.value)
                                              .smsCount >= 3 &&
                                            smsCounter(e.target.value)
                                              .charsLeft <= -1
                                          ) {
                                            return;
                                          }
                                          this.setState(
                                            {
                                              smsTemplateValue: e.target.value,
                                              templateIdSMS: "",
                                            });
                                          this.setSms({
                                            key: "smsTemplateValue",
                                            value: e.target.value,
                                          });
                                          this.setSms({
                                            key: "templateIdSMS",
                                            value: "",
                                          });
                                          // this.textAreaRef.current.setAttribute('style', 'height:auto;');
                                          // const styles = Object.entries(this.textAreaStyle)
                                          // .map(([key, value]) => `${key}: ${value}`)
                                          // .join("; ");
                                          // this.textAreaRef.current.setAttribute('style', `${styles}; height:${this.textAreaRef.current.scrollHeight + 30}px;`);
                                        }}
                                      />
                                    </FormGroup>
                                    {/* <CharacterCounts>
                              <span className='dark-text'>Character:</span>{sms.smsTemplateValue ? smsCounter(sms.smsTemplateValue).smsCount: 0}&nbsp;
                              <span className='dark-text'>SMS Parts: </span> {sms.smsTemplateValue? Math.ceil(sms.smsTemplateValue.length/160): 0}
                            </CharacterCounts> */}
                                    <CharacterCounts>
                                      <span className="dark-text">
                                        Characters Left :{" "}
                                      </span>{" "}
                                      {sms.smsTemplateValue
                                        ? smsCounter(sms.smsTemplateValue)
                                          .charsLeft
                                        : 160}
                                      &nbsp;
                                      <span className="dark-text">SMS :</span>
                                      {sms.smsTemplateValue
                                        ? smsCounter(sms.smsTemplateValue)
                                          .smsCount
                                        : 0}
                                      /3
                                    </CharacterCounts>
                                    <SMForm>
                                      {sms.smsButtons &&
                                        sms.smsButtons.map((ele) => {
                                          return this.renderFormGroup(ele, {
                                            buttonWidth: "50%",
                                            defaultValue: "",
                                            placeholder: `${ele}`,
                                            // autoFocus: true,
                                            required: true,
                                            id: "To",
                                            maxWidth: "50%",
                                            // value: this.state.ele,
                                            // value: eval(`this.state.smsButton${ele}`)?eval(`this.state.smsButton${ele}`) : '',
                                            value: sms[`smsButton${ele}`]
                                              ? sms[`smsButton${ele}`]
                                              : "",
                                            onChange: async (e) => {
                                              if (e.target && e.target.value) {
                                                // this.setState({ [`smsButton${ele}`]: e.target.value },()=>{
                                                //   this.replaceVar('sms');
                                                // });
                                                await this.setSms({
                                                  key: `smsButton${ele}`,
                                                  value: e.target.value,
                                                });
                                                this.replaceVar("sms");
                                              } else {
                                                // this.setState({ [`smsButton${ele}`]: "" },()=>{
                                                //   this.replaceVar('sms');
                                                // });
                                                await this.setSms({
                                                  key: `smsButton${ele}`,
                                                  value: "",
                                                });
                                                this.replaceVar("sms");
                                              }
                                            },
                                          });
                                        })}
                                    </SMForm>
                                    {this.renderSendButton("sms")}
                                  </FormColumn>
                                </FormWrapper>
                              </div>
                            </Col>
                            <Col
                              md={sms.showAvailabeSMSTemplates ? 5 : 0}
                              style={{
                                width: "39%",
                                display: sms.showAvailabeSMSTemplates
                                  ? ""
                                  : "none",
                              }}
                            >
                              {this.renderHeader("Available SMS Templates")}
                              {this.renderSearch({
                                onChange: (e) => this.searchSMS(e, smsList),
                                value: this.state.searchValueSMS,
                              })}
                              <div
                                className="mt-3"
                                style={{
                                  height: "calc(100vh - 280px)",
                                  overflow: "auto",
                                  wordBreak: "break-word",
                                }}
                              >
                                {/* <DataWithLoader
                          data={SMSList}
                          loading={this.state.loadingSMS}
                          size={this.state.listDataSMS.length}
                          count={this.state.listDataSMS.length}
                          emptyText="No Template Found."
                          // emptyImage="/images/emptySIP.png"
                        /> */}
                                {this.state.searchValueSMS
                                  ? searchSMSList
                                  : SMSList}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Tab>
                    )}
                    {/* </div> */}
                  </Tabs>
                </div>
              </TabItemsStyle>
            </Col>
            <Col md={showAgentAssist ? 4 : 0} className="p-0">
              {showAgentAssist ? (
                <div>
                  <HeaderAgent>
                    {/* <img src="/images/icons/Copilote.png" /> */}
                    <FaWandMagicSparkles
                      style={{
                        fontSize: "20px",
                        display: "block",
                        color: "rgb(72, 96, 217)",
                      }}
                    />
                    <h6>Smart Assistant</h6>
                    <ButtonCommonTheme
                      type="clearChatLink"
                      // btnType="submit"
                      btnStyle="default"
                      className=""
                      size="small"
                      onClick={this.clearChat}
                    // onClick={() => {
                    //   this.props.setAgentAssist([]);
                    //   // this.setState({ suggestionsList: [] });
                    // }}
                    />
                  </HeaderAgent>
                  {agentAssist && (
                    <ul className="suggestionBox chat-container">
                      {agentAssist.map((item, index) => (
                        <div
                          key={index}
                          className={`chat-row ${item.key === "Question" ? "question" : "answer"
                            }`}
                        >
                          {item.key === "Question" && (
                            <li
                              className="chat-bubble question-bubble"
                              key={index}
                            >
                              {" "}
                              {item.value}
                              <div className="message-info-td">
                                <span
                                  class="material-symbols-outlined message-copy"
                                  onClick={() => {
                                    if (item.value) {
                                      navigator.clipboard.writeText(item.value);
                                      Alert.success(
                                        "Message copied successfully"
                                      );
                                    } else {
                                      Alert.error("Message not copy");
                                    }
                                  }}
                                >
                                  content_copy
                                </span>
                              </div>
                            </li>
                            // <div className="resQuestion">
                            //   {item.value}
                            // </div>
                          )}
                          {item.key === "Answer" && (
                            <div className="chat-bubble answer-bubble">
                              {Array.isArray(item.value)
                                ? item.value.map((answer, idx) => (
                                  // <div key={idx}>
                                  answer.method !== "error" ?
                                    <li
                                      key={idx}
                                      // className={`${
                                      //   answer.method === "error" ? "error" : ""
                                      // }`}
                                      style={{ padding: '10px', borderRadius: '10px', backgroundColor: '#f3f3f3' }}
                                    >
                                      {" "}
                                      {answer.type === "text" && (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: answer.content,
                                          }}
                                        />
                                      )}
                                      <div className="message-info-td">
                                        <span
                                          class="material-symbols-outlined message-copy"
                                          onClick={() => {
                                            if (answer.content) {
                                              navigator.clipboard.writeText(
                                                answer.content
                                              );
                                              Alert.success(
                                                "Message copied successfully"
                                              );
                                            } else {
                                              Alert.error("Message not copy");
                                            }
                                          }}
                                        >
                                          content_copy
                                        </span>
                                      </div>
                                    </li> :
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                      <span class="material-symbols-outlined" style={{ color: '#EA475D' }}>
                                        refresh
                                      </span>
                                      <li key={idx}
                                        className={`${answer.method === "error" ? "error" : ""
                                          }`}
                                        style={{ padding: '10px', borderRadius: '10px' }}>

                                        {answer.type === "text" && (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: answer.content,
                                            }}
                                          />
                                        )}
                                      </li>
                                    </div>
                                ))
                                : "No message"}
                            </div>
                          )}
                        </div>
                      ))}
                    </ul>
                  )}
                  <form onSubmit={(e) => this.saveData(e)}>
                    <FormWrapper>
                      <FormGroup className="w-100">
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "10px", padding: "0px 14px" }}
                        >
                          {/* <button
                                    className="suggession_btn"
                                    type="submit"
                                  >
                                    <FaWandMagicSparkles
                                      style={{
                                        fontSize: "16px",
                                        display: "block",
                                      }}
                                    />
                                  </button> */}
                          <ButtonCommonTheme
                            type="blueModalBtn"
                            btnType="submit"
                            btnStyle="default"
                            className="p-3"
                            size="small"
                            isLoading={this.state.isLoading}
                            disabled={this.state.isLoading}
                            style={{
                              background: "transparent",
                              padding: "8px",
                              border: "2px solid #4860D9",
                            }}
                          >
                            <FaWandMagicSparkles
                              style={{
                                fontSize: "16px",
                                display: "block",
                                color: "rgb(72, 96, 217)",
                              }}
                            />
                            {/* <img
                              src="/images/icons/Copilote.png"
                              style={{ width: "26px", height: "20px" }}
                            /> */}
                          </ButtonCommonTheme>
                          <FormControl
                            type="text"
                            placeholder={"Type to search"}
                            onChange={(e) => {
                              if (e.target.value === " ") {
                                return false;
                              }
                              this.setState({ prompt: e.target.value });
                            }}
                            value={this.state.prompt}
                          // autoFocus
                          // onFocus={(e) => this.moveCursorAtTheEnd(e)}
                          />

                          {/* <button
                                    className="suggession_btn"
                                    disabled={
                                      !this.state.prompt.trim() ||
                                      this.state.isLoading
                                    }
                                    type="submit"
                                  >
                                    <FaWandMagicSparkles
                                      style={{
                                        fontSize: "16px",
                                        display: "block",
                                      }}
                                    />
                                  </button> */}
                        </div>
                      </FormGroup>
                    </FormWrapper>
                  </form>
                  {/* {this.state.suggestionsList && (
                <ul className="suggestionBox">
                  {this.state.suggestionsList &&
                    this.state.suggestionsList.map((data, index) => {
                      return (
                        data &&
                        data.content && <li key={index}>{data.content}</li>
                      );
                    })}
                </ul>
              )} */}
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </InsightRow>
      </DataWrapperClass>
    );
  }
}
const stateToProps = (state) => ({
  callInfo: globalStateSelector.getInfo(state),
  callTeam: globalStateSelector.getDynamic(state, { key: "callTeam" }),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),
  email: smsemailSelector.getEmail(state),
  sms: smsemailSelector.getSms(state),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  // activeTab: smsemailSelector.getActiveTab(state)
  callTranscript: globalStateSelector.getTranscriptionSet(state),
  callTagList: globalStateSelector.getDynamic(state, { key: "callTagList" }),
  agentAssist: globalStateSelector.getAgentAssist(state),
  summary: globalStateSelector.getSummary(state),
});
const dispatchToProps = (dispatch) => ({
  setSms: (data) => {
    dispatch(smsemailAction.setSms({ data }));
  },
  setEmail: (data) => {
    dispatch(smsemailAction.setEmail({ data }));
  },
  setAgentAssist: (data) => {
    dispatch(callAction.setAgentAssist({ data }));
  },
  clearAgentAssist: () => dispatch(callAction.clearAgentAssist()),
  updateTranslateCall: (id, translatedText) => {
    dispatch(callAction.updateTranslateCall(id, translatedText));
  },
  // setActiveTab: data => {
  //   dispatch(smsemailAction.setActiveTab({data}))
  // }
});
export default connect(
  stateToProps,
  dispatchToProps
)(ContactInfoActivityTimelineTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactInfoActivityTimelineTheme.js